import { render, staticRenderFns } from "./BannerProduct.vue?vue&type=template&id=33b1dc92&scoped=true&"
import script from "./BannerProduct.vue?vue&type=script&lang=js&"
export * from "./BannerProduct.vue?vue&type=script&lang=js&"
import style0 from "./BannerProduct.vue?vue&type=style&index=0&id=33b1dc92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b1dc92",
  null
  
)

export default component.exports